import genericContentItemAnswer
  from '@shared/components/mixins/genericContentItemAnswer'
import anime from 'animejs/lib/anime.es.js'
import pxToEm from '@shared/components/mixins/shared/pxToEm'

export default {
  name: 'FortuneWheel',
  mixins: [genericContentItemAnswer, pxToEm],
  props: {
    component: {
      type: Object,
      required: true,
    },
    isEditor: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      wheelSpinning: false,
    }
  },
  computed: {
    prizesLength() {
      return this.component.content.prizes.length
    },
    styleObject() {
      const wheelDiameter = 21
      const wheelRadius = wheelDiameter / 2
      const prizesLength = this.prizesLength
      const sliceHeight = (6.283185307 * wheelRadius) / prizesLength
      return {
        '--wheel-text-color': this.emStyling.color,
        '--wheel-slice-color': this.emStyling.backgroundColor,
        '--wheel-slice-secondary-color': this.emStyling.secondaryBackgroundColor,
        '--wheel-diameter': wheelDiameter + 'em',
        '--wheel-radius': wheelRadius + 'em',
        '--wheel-slice-height': sliceHeight + 'em',
        '--wheel-slice-offset': sliceHeight / 2 + 'em',
      }
    },
  },
  created() {
    if (!this.isEditor) {
      this.$eventBus.$on('trigger-wheel-spin', () => {
        if (!this.wheelSpinning) {
          this.spinWheel()
        }
      })
    }
  },
  methods: {
    spinWheel() {
      this.wheelSpinning = true
      const wheel = this.$refs.wheel
      const numItems = this.component.content.prizes.length
      const arc = 360 / numItems
      const prizeIndex = this.getRandomWeighedIndex()
      const random = (numItems - prizeIndex) * arc + 1080 - arc / 2
      const prize = this.component.content.prizes[prizeIndex]

      anime({
        targets: wheel,
        rotate: `+=${random}`,
        duration: 3200,
        easing: 'easeInOutQuart',
        complete: () => {
          this.answer.value = prize.value
          this.answer.optionID = prize.id
          this.$eventBus.$emit('fortune-wheel-answer', this.answer)
          this.wheelSpinning = false
        },
      })
    },
    getRandomWeighedIndex() {
      const data = this.component.content.prizes
      let total = 0

      // Courtesy of https://blobfolio.com/2019/randomizing-weighted-choices-in-javascript/
      for (let i = 0; i < data.length; ++i) {
        total += parseInt(data[i].weight)
      }

      const threshold = Math.random() * total
      total = 0

      for (let i = 0; i < data.length - 1; ++i) {
        // Add the weight to our running total.
        total += parseInt(data[i].weight)

        // If this value falls within the threshold, we're done!
        if (total >= threshold) {
          return i
        }
      }

      // Wouldn't you know it, we needed the very last entry!
      return data.length - 1
    },
  },
}
